export class Component {
  static defaultOptions = {
    tagName: 'div',
    componentName: 'component'
  };

  constructor (options) {
    this.options = $.extend({}, Component.defaultOptions, options);

    if (this.options.element) this.el = $(options.element);
    else this.el = $(document.createElement(this.options.tagName));

    this.el.addClass(this.getComponentClass());
  }

  getComponentClass () {
    return 'ca-ui-' + this.options.componentName.toLowerCase();
  }

  on (event, callback) {
    return this.el.on(event, callback);
  }

  css (style, value) {
    return this.el.css(style, value);
  }

  add (child) {
    if (child instanceof Component) this.el.append(child.el);
    else this.el.append(child);
  }

  hide () {
    this.el.hide();
  }

  show () {
    this.el.show();
  }

  toggle (toggle) {
    this.el.toggle(toggle);
  }
}
